import styled from "styled-components";

export const ModalContainer = styled.div`
	display: flex;
	width: 100%;
	height: 600px;
	overflow: hidden;
`;
